import { Validator } from "vee-validate";
import {
  validatorFirstCharacterMustCapitalized,
  validatorEndCharacterMustDots,
  validatorExpression,
  validatorPhone,
} from "./validators";

Validator.extend("end_character_must_dots", {
  validate: validatorEndCharacterMustDots,
  getMessage: "The last letter must be a dots",
});

Validator.extend("first_character_must_capitalized", {
  validate: validatorFirstCharacterMustCapitalized,
  getMessage: "The first letter must be capitalized",
});

Validator.extend("validate_expression", {
  validate: validatorExpression,
  getMessage:
    "The last letter must be a dots, exclamation mark, or question mark",
});

Validator.extend("validate_phone", {
  validate: validatorPhone,
  getMessage: "Phone is invalid",
});
